import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MarketPage } from './market.page';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./order-provider/order-provider.module').then(m => m.OrderProviderPageModule),
    data: {
      breadcrumb: 'MENU.MARKET_PLACE'
    },
  },
    {
    path: 'provider/:providerId',
    component: MarketPage,
    data: {
      breadcrumb: 'MARKET.PROVIDER'
    },
  },
  {
    path: 'provider/product/:providerId/:productId',
    loadChildren: () => import('./product/product.module').then(m => m.ProductPageModule),
    data: {
      breadcrumb: 'MARKET.PRODUCT_DETAILS'
    },
  },
  {
    path: 'provider/product/:providerId',
    loadChildren: () => import('./product/product.module').then(m => m.ProductPageModule),
    data: {
      breadcrumb: 'MARKET.NEW_PRODUCT'
    },
  },
  {
    path: 'order/:id',
    loadChildren: () => import('./order-details/order-details.module').then(m => m.OrderDetailsPageModule),
    data: {
      breadcrumb: 'MARKET.ORDER'
    },
  },
  {
    path: 'category-modal',
    loadChildren: () => import('./category-modal/category-modal.module').then(m => m.CategoryModalPageModule)
  },
  {
    path: 'cart/:providerId',
    loadChildren: () => import('./cart/cart.module').then( m => m.CartPageModule),
    data: {
      breadcrumb: 'MARKET.BASKET'
    },
  },


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MarketPageRoutingModule { }


